import React, { SVGProps } from "react";

export default function SupPinLeft(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.3 10.4V10.1V9.89995V9.59995V6.79995C7.3 6.19244 7.79249 5.69995 8.4 5.69995H9.10557C9.46435 5.69995 9.79234 5.90266 9.95279 6.22356C10.2826 6.88324 10.9569 7.29995 11.6944 7.29995H15.0343C15.5291 7.29995 16.0037 7.10339 16.3536 6.7535L16.4222 6.68488L16.0686 6.33132L16.4222 6.68488C16.5406 6.56647 16.7012 6.49995 16.8686 6.49995C17.2173 6.49995 17.5 6.78263 17.5 7.13132V12.8686C17.5 13.2173 17.2173 13.5 16.8686 13.5C16.7012 13.5 16.5406 13.4334 16.4222 13.315L16.3536 13.2464C16.0037 12.8965 15.5291 12.7 15.0343 12.7H11.6944C10.9569 12.7 10.2826 13.1167 9.95279 13.7763C9.79234 14.0972 9.46435 14.3 9.10557 14.3H8.4C7.79249 14.3 7.3 13.8075 7.3 13.2V10.4Z"
        stroke="currentColor"
      />
    </svg>
  );
}
